export default __webpack_public_path__ + "9d8df730909215c2d72f5d61aebf1b11.svg";